import { render, staticRenderFns } from "./SavList.vue?vue&type=template&id=19edf47c&"
import script from "./SavList.vue?vue&type=script&lang=js&"
export * from "./SavList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports